/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ExposureMode {
}

export enum ExposureMode_Enum {
  EXP_MODE_AUTO = 0,
  EXP_MODE_24 = 41666666,
  EXP_MODE_30 = 33333333,
  EXP_MODE_48 = 20833333,
  EXP_MODE_60 = 16666666,
  EXP_MODE_96 = 10416666,
  EXP_MODE_120 = 8333333,
  EXP_MODE_240 = 4166666,
  EXP_MODE_480 = 2083333,
  EXP_MODE_960 = 1041666,
  EXP_MODE_1920 = 520833,
  EXP_MODE_3840 = 260416,
  EXP_MODE_7680 = 130208,
  UNRECOGNIZED = -1,
}

export function exposureMode_EnumFromJSON(object: any): ExposureMode_Enum {
  switch (object) {
    case 0:
    case "EXP_MODE_AUTO":
      return ExposureMode_Enum.EXP_MODE_AUTO;
    case 41666666:
    case "EXP_MODE_24":
      return ExposureMode_Enum.EXP_MODE_24;
    case 33333333:
    case "EXP_MODE_30":
      return ExposureMode_Enum.EXP_MODE_30;
    case 20833333:
    case "EXP_MODE_48":
      return ExposureMode_Enum.EXP_MODE_48;
    case 16666666:
    case "EXP_MODE_60":
      return ExposureMode_Enum.EXP_MODE_60;
    case 10416666:
    case "EXP_MODE_96":
      return ExposureMode_Enum.EXP_MODE_96;
    case 8333333:
    case "EXP_MODE_120":
      return ExposureMode_Enum.EXP_MODE_120;
    case 4166666:
    case "EXP_MODE_240":
      return ExposureMode_Enum.EXP_MODE_240;
    case 2083333:
    case "EXP_MODE_480":
      return ExposureMode_Enum.EXP_MODE_480;
    case 1041666:
    case "EXP_MODE_960":
      return ExposureMode_Enum.EXP_MODE_960;
    case 520833:
    case "EXP_MODE_1920":
      return ExposureMode_Enum.EXP_MODE_1920;
    case 260416:
    case "EXP_MODE_3840":
      return ExposureMode_Enum.EXP_MODE_3840;
    case 130208:
    case "EXP_MODE_7680":
      return ExposureMode_Enum.EXP_MODE_7680;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExposureMode_Enum.UNRECOGNIZED;
  }
}

export function exposureMode_EnumToJSON(object: ExposureMode_Enum): string {
  switch (object) {
    case ExposureMode_Enum.EXP_MODE_AUTO:
      return "EXP_MODE_AUTO";
    case ExposureMode_Enum.EXP_MODE_24:
      return "EXP_MODE_24";
    case ExposureMode_Enum.EXP_MODE_30:
      return "EXP_MODE_30";
    case ExposureMode_Enum.EXP_MODE_48:
      return "EXP_MODE_48";
    case ExposureMode_Enum.EXP_MODE_60:
      return "EXP_MODE_60";
    case ExposureMode_Enum.EXP_MODE_96:
      return "EXP_MODE_96";
    case ExposureMode_Enum.EXP_MODE_120:
      return "EXP_MODE_120";
    case ExposureMode_Enum.EXP_MODE_240:
      return "EXP_MODE_240";
    case ExposureMode_Enum.EXP_MODE_480:
      return "EXP_MODE_480";
    case ExposureMode_Enum.EXP_MODE_960:
      return "EXP_MODE_960";
    case ExposureMode_Enum.EXP_MODE_1920:
      return "EXP_MODE_1920";
    case ExposureMode_Enum.EXP_MODE_3840:
      return "EXP_MODE_3840";
    case ExposureMode_Enum.EXP_MODE_7680:
      return "EXP_MODE_7680";
    case ExposureMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseExposureMode(): ExposureMode {
  return {};
}

export const ExposureMode = {
  encode(_: ExposureMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExposureMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExposureMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ExposureMode {
    return {};
  },

  toJSON(_: ExposureMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ExposureMode>, I>>(base?: I): ExposureMode {
    return ExposureMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExposureMode>, I>>(_: I): ExposureMode {
    const message = createBaseExposureMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
